// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.typography-section[data-v-64586774] {
  flex: 0 0 60%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  height: 100vh;
}
.animated-weather-elements[data-v-64586774] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  overflow: hidden;
  pointer-events: none;
}
.cloud[data-v-64586774] {
  position: absolute;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 100px;
  z-index: 3;
  box-shadow: inset -20px -20px 40px rgba(0, 0, 0, 0.2);
}
.cloud[data-v-64586774]::before,
.cloud[data-v-64586774]::after {
  content: "";
  position: absolute;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 100px;
}
.cloud-1[data-v-64586774] {
  width: 250px;
  height: 80px;
  top: 15%;
  left: -250px;
  animation: drift-64586774 25s infinite linear;
}
.cloud-1[data-v-64586774]::before {
  width: 120px;
  height: 120px;
  top: -60px;
  left: 20px;
}
.cloud-1[data-v-64586774]::after {
  width: 180px;
  height: 100px;
  top: -40px;
  right: 20px;
}
.cloud-2[data-v-64586774] {
  width: 200px;
  height: 70px;
  top: 40%;
  right: -200px;
  animation: drift-reverse-64586774 30s infinite linear;
  opacity: 0.6;
}
.cloud-2[data-v-64586774]::before {
  width: 100px;
  height: 100px;
  top: -50px;
  left: 20px;
}
.cloud-2[data-v-64586774]::after {
  width: 150px;
  height: 90px;
  top: -35px;
  right: 20px;
}
@keyframes drift-64586774 {
from {
    left: -250px;
}
to {
    left: 100%;
}
}
@keyframes drift-reverse-64586774 {
from {
    right: -200px;
}
to {
    right: 100%;
}
}
.wind-gust[data-v-64586774] {
  position: absolute;
  height: 1px;
  background: linear-gradient(to right, rgba(100, 150, 255, 0.3), transparent);
  top: 50%;
  left: -150px;
  width: 300px;
  z-index: 3;
}
.wind-1[data-v-64586774] {
  top: 25%;
  animation: wind-blow-64586774 4s infinite ease-in-out;
}
.wind-2[data-v-64586774] {
  top: 65%;
  animation: wind-blow-64586774 5s 1.5s infinite ease-in-out;
  opacity: 0.5;
}
@keyframes wind-blow-64586774 {
0%,
  100% {
    left: -150px;
    opacity: 0;
}
50% {
    opacity: 1;
}
to {
    left: 100%;
}
}
.storm-indicator[data-v-64586774] {
  position: absolute;
  width: 300px;
  height: 300px;
  top: 20%;
  right: -100px;
  background: radial-gradient(
    circle,
    rgba(45, 219, 182, 0.1) 0%,
    transparent 70%
  );
  border-radius: 50%;
  z-index: 3;
  animation: storm-pulse-64586774 4s ease-in-out infinite;
}
@keyframes storm-pulse-64586774 {
0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
}
50% {
    opacity: 0.6;
    transform: scale(1.1);
}
}
@media (max-width: 1024px) {
.typography-section[data-v-64586774] {
    flex: 0 0 auto;
    height: auto;
    min-height: 40vh;
}
}
@media (max-width: 480px) {
.typography-section[data-v-64586774] {
    display: none;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/LeftSection/LeftSection.vue"],"names":[],"mappings":";AA4BA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,UAAU;EACV,qDAAqD;AACvD;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,6CAAoC;AACtC;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;AACZ;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;AACb;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,qDAA4C;EAC5C,YAAY;AACd;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;AACZ;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AAEA;AACE;IACE,YAAY;AACd;AACA;IACE,UAAU;AACZ;AACF;AAEA;AACE;IACE,aAAa;AACf;AACA;IACE,WAAW;AACb;AACF;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4EAA4E;EAC5E,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;AAEA;EACE,QAAQ;EACR,qDAA4C;AAC9C;AAEA;EACE,QAAQ;EACR,0DAAiD;EACjD,YAAY;AACd;AAEA;AACE;;IAEE,YAAY;IACZ,UAAU;AACZ;AACA;IACE,UAAU;AACZ;AACA;IACE,UAAU;AACZ;AACF;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,aAAa;EACb;;;;GAIC;EACD,kBAAkB;EAClB,UAAU;EACV,uDAA8C;AAChD;AAEA;AACE;;IAEE,YAAY;IACZ,mBAAmB;AACrB;AACA;IACE,YAAY;IACZ,qBAAqB;AACvB;AACF;AAEA;AACE;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;AAClB;AACF;AAEA;AACE;IACE,aAAa;AACf;AACF","sourcesContent":["<template>\n  <div class=\"typography-section\">\n    <WeatherBackground />\n    <div class=\"animated-weather-elements\">\n      <div class=\"cloud cloud-1\"></div>\n      <div class=\"cloud cloud-2\"></div>\n      <div class=\"wind-gust wind-1\"></div>\n      <div class=\"wind-gust wind-2\"></div>\n      <div class=\"storm-indicator\"></div>\n    </div>\n    <BrandHero />\n  </div>\n</template>\n\n<script>\nimport WeatherBackground from \"./WeatherBackground.vue\";\nimport BrandHero from \"./BrandHero.vue\";\n\nexport default {\n  name: \"LeftSection\",\n  components: {\n    WeatherBackground,\n    BrandHero,\n  },\n};\n</script>\n\n<style scoped>\n.typography-section {\n  flex: 0 0 60%;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  height: 100vh;\n}\n\n.animated-weather-elements {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.cloud {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 100px;\n  z-index: 3;\n  box-shadow: inset -20px -20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.cloud::before,\n.cloud::after {\n  content: \"\";\n  position: absolute;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 100px;\n}\n\n.cloud-1 {\n  width: 250px;\n  height: 80px;\n  top: 15%;\n  left: -250px;\n  animation: drift 25s infinite linear;\n}\n\n.cloud-1::before {\n  width: 120px;\n  height: 120px;\n  top: -60px;\n  left: 20px;\n}\n\n.cloud-1::after {\n  width: 180px;\n  height: 100px;\n  top: -40px;\n  right: 20px;\n}\n\n.cloud-2 {\n  width: 200px;\n  height: 70px;\n  top: 40%;\n  right: -200px;\n  animation: drift-reverse 30s infinite linear;\n  opacity: 0.6;\n}\n\n.cloud-2::before {\n  width: 100px;\n  height: 100px;\n  top: -50px;\n  left: 20px;\n}\n\n.cloud-2::after {\n  width: 150px;\n  height: 90px;\n  top: -35px;\n  right: 20px;\n}\n\n@keyframes drift {\n  from {\n    left: -250px;\n  }\n  to {\n    left: 100%;\n  }\n}\n\n@keyframes drift-reverse {\n  from {\n    right: -200px;\n  }\n  to {\n    right: 100%;\n  }\n}\n\n.wind-gust {\n  position: absolute;\n  height: 1px;\n  background: linear-gradient(to right, rgba(100, 150, 255, 0.3), transparent);\n  top: 50%;\n  left: -150px;\n  width: 300px;\n  z-index: 3;\n}\n\n.wind-1 {\n  top: 25%;\n  animation: wind-blow 4s infinite ease-in-out;\n}\n\n.wind-2 {\n  top: 65%;\n  animation: wind-blow 5s 1.5s infinite ease-in-out;\n  opacity: 0.5;\n}\n\n@keyframes wind-blow {\n  0%,\n  100% {\n    left: -150px;\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  to {\n    left: 100%;\n  }\n}\n\n.storm-indicator {\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  top: 20%;\n  right: -100px;\n  background: radial-gradient(\n    circle,\n    rgba(45, 219, 182, 0.1) 0%,\n    transparent 70%\n  );\n  border-radius: 50%;\n  z-index: 3;\n  animation: storm-pulse 4s ease-in-out infinite;\n}\n\n@keyframes storm-pulse {\n  0%,\n  100% {\n    opacity: 0.3;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.1);\n  }\n}\n\n@media (max-width: 1024px) {\n  .typography-section {\n    flex: 0 0 auto;\n    height: auto;\n    min-height: 40vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .typography-section {\n    display: none;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
